import { Injectable } from "@angular/core";
import { SessionStorageMode } from "./session-storage.mode";
import { SessionStorageEngine } from "./session-storage.interface";
import { SessionStorageBrowserEngine } from "./session-storage.browser";
import { SessionStorageNativeEngine } from "./session-storage.native";

@Injectable()
export class SessionStorageProvider
{

    //#region Constructors

    /**
     * Class constructor
     */
    constructor()
    {

    }

    //#endregion


    //#region Properties

    /**
     * Engine performing the calls
     */
    private sessionStorageEngine: SessionStorageEngine;

    //#endregion

    //#region Methods

    /**
    * Initialize the provider
    * @param mode type of mode SessionStorage to instantiate
    */
    public async initializeProvider(mode: SessionStorageMode): Promise<void>
    {
        switch (mode)
        {
            case SessionStorageMode.BROWSER: {
                // if browser load the engine using the angular 
                // http client instead
                this.sessionStorageEngine = new SessionStorageBrowserEngine();
                break;
            }
            case SessionStorageMode.NATIVE: {
                // if the device in question is an application
                // load the engine with the native plugin
                this.sessionStorageEngine = new SessionStorageNativeEngine();
                break;
            }
            default: {
                throw new Error("Invalid Core Session Storage Mode provided!");
            }
        }
    }

    /**
    * Get value in index
    * @param {string} key identifier for data to get
    */
    public async getValue(key: string): Promise<any>
    {
        return await this.sessionStorageEngine.getValue(key);
    }


    /**
    * Set value of index location
    * @param {string} key identifier for data to set
    * @param {any} value value to asign in index location
    */
    public setValue(key: string, value: any)
    {
        this.sessionStorageEngine.setValue(key, value);
    }

    /**
    * Clears all date in session
    */
    public clearSessionStorage(): void
    {
        this.sessionStorageEngine.clearSessionStorage();
    }

    //#endregion
}
